
import * as d3 from 'd3'
export default {
  methods: {

    draw_Search() {

      let data__ = {
        x         : this.search.x,
        y         : this.search.y,
        width     : 200,
        height    : 65.5,
        label     : 'Search',
        labelWidth: 40,
        targets: [{text: this.search.note},],
        callFunc: this.call_Search,
      }
      this.gmx_SearchTool(this.canvasForm, data__) //---> Global function
    }, 

    
    call_Search(input=null, from) {
      
      this.search.input = input
      this.search.results = input ? this.skyline.data.filter(f => f[this.codes.skyline].toLowerCase().includes(input.toLowerCase())) : []

      this.rawData.forEach(d => {
        if(this.search.results.find(f => f[this.codes.skyline] == d[this.codes.skyline])) {
          d.opacity = 1
        } else {
          d.opacity = .2
        }
        if(input == null || input == '') d.opacity = 1
        d3.select(`#BOX_${d.SYS}_${d[this.codes.skyline]}`).attr('cursor', d.opacity < 1 ? 'default' : 'pointer').attr('opacity', d.opacity)
      })

    },

  }
}